// In development, use proxy (same origin) to avoid cross-port cookie issues
// Proxy is configured in vite.config.mjs to forward /api to http://127.0.0.1:8000
// In production, use full URL from environment variable

type RuntimeWindow = typeof window & {
  API_BASE?: string | undefined;
};

export function getApiBase(): string {
  // Check environment variable first (highest priority)
  const envBase = typeof import.meta !== "undefined" ? import.meta.env?.VITE_API_BASE : undefined;
  if (typeof envBase === "string" && envBase.length > 0) {
    return envBase;
  }

  // Check runtime window variable (for testing/debugging)
  if (typeof window !== "undefined") {
    const runtimeWindow = window as RuntimeWindow;
    if (runtimeWindow.API_BASE && runtimeWindow.API_BASE.length > 0) {
      return runtimeWindow.API_BASE;
    }
  }

  // In development mode, use empty string to use proxy (same origin)
  // This makes all requests come from localhost:5173 (via proxy)
  // In production, use empty string (nginx proxies /api to backend)
  // The built files are served behind nginx which handles the proxy.
  const isDev = typeof import.meta !== "undefined" && import.meta.env?.DEV === true;

  // Both dev (Vite proxy) and production (Nginx proxy) use same-origin API calls
  return "";
}


